import { render } from "./btn.vue?vue&type=template&id=0f655465&scoped=true"
import script from "./btn.vue?vue&type=script&lang=js"
export * from "./btn.vue?vue&type=script&lang=js"

import "./btn.vue?vue&type=style&index=0&id=0f655465&scoped=true&lang=css"

import exportComponent from "/Users/user/crud-projects/crederi-all/crederi_2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f655465"]])

export default __exports__